import React from 'react';
import Header from '../../components/ui/Header';
import Seo from '../../components/Seo';
import Icon from '../../components/AppIcon';

const SecurityPage = () => {
  const certUrl = 'https://registry.blockmarktech.com/certificates/7150f0f9-eacc-4a5a-a484-c00107793ce0/';

  return (
    <>
      <Seo
        title="Security | Neevii"
        description="Learn about Neevii's security practices and certifications including Cyber Essentials."
      />
      <div className="min-h-screen">
        <Header />
        <main className="pt-24 pb-16 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-4">Security</h1>
            <p className="text-xl text-muted-foreground mb-12">
              Your data security is our top priority. Here's how we protect your financial information.
            </p>

            {/* Cyber Essentials Badge */}
            <section className="mb-12 p-8 bg-card rounded-2xl border border-border">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <a href={certUrl} target="_blank" rel="noopener noreferrer">
                  <div style={{ width: '66px', height: '66px', overflow: 'hidden' }}>
                    <iframe
                      src="https://registry.blockmarktech.com/certificates/7150f0f9-eacc-4a5a-a484-c00107793ce0/widget/?tooltip_position=bottom&theme=transparent"
                      style={{
                        border: 'none',
                        height: '132px',
                        width: '132px',
                        transform: 'scale(0.5)',
                        transformOrigin: 'top left',
                        pointerEvents: 'none'
                      }}
                      title="Cyber Essentials Certified"
                    />
                  </div>
                </a>
                <div className="flex-1 text-center md:text-left">
                  <h2 className="text-2xl font-bold text-foreground mb-2">Cyber Essentials Certified</h2>
                  <p className="text-muted-foreground mb-4">
                    Neevii is certified under the UK Government's Cyber Essentials scheme, demonstrating our commitment to protecting against common cyber threats.
                  </p>
                  <a 
                    href={certUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-accent hover:underline"
                  >
                    View our certificate
                    <Icon name="ExternalLink" size={16} className="ml-2" />
                  </a>
                </div>
              </div>
            </section>

            {/* Security Features */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-foreground mb-6">How We Protect Your Data</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {[
                  { icon: 'Lock', title: 'Encryption', desc: 'AES-256 encryption for data at rest and TLS 1.3 for data in transit' },
                  { icon: 'Shield', title: 'Access Control', desc: 'Multi-factor authentication and role-based access controls' },
                  { icon: 'Server', title: 'Secure Infrastructure', desc: 'UK-based data centres with ISO 27001 certification' },
                  { icon: 'Eye', title: 'Monitoring', desc: '24/7 security monitoring and automated threat detection' },
                  { icon: 'RefreshCw', title: 'Backups', desc: 'Automated daily backups with encrypted off-site storage' },
                  { icon: 'FileCheck', title: 'Compliance', desc: 'GDPR compliant data handling and processing' },
                ].map((item, i) => (
                  <div key={i} className="p-6 bg-card rounded-xl border border-border">
                    <div className="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mb-4">
                      <Icon name={item.icon} size={24} className="text-accent" />
                    </div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">{item.title}</h3>
                    <p className="text-muted-foreground text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section className="p-8 bg-card rounded-2xl border border-border text-center">
              <h2 className="text-2xl font-bold text-foreground mb-4">Security Questions?</h2>
              <p className="text-muted-foreground mb-6">
                If you have any security concerns or questions, please contact our security team.
              </p>
              <a
                href="mailto:support@neevii.com?subject=Security%20Question"
                className="inline-flex items-center px-6 py-3 bg-accent text-accent-foreground rounded-lg font-medium hover:bg-accent/90 transition-colors cursor-pointer"
              >
                <Icon name="Mail" size={20} className="mr-2" />
                Contact Support
              </a>
              <p className="text-xs text-muted-foreground mt-3">
                Right-click to copy email address
              </p>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default SecurityPage;

